import React from 'react';
import './Input.css';

const Checkbox = ({
  title,
  checked,
  onChange,
  required = false,
  disabled = false,
  error,
  className = "",
  ...props
}) => {
  return (
    <div className={`input-container checkbox-container ${className}`}>
      <div className="checkbox-wrapper">
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          required={required}
          disabled={disabled}
          className={`checkbox-field ${error ? 'input-error' : ''}`}
          {...props}
        />
        {title && (
          <label className="checkbox-title">
            {title}
            {required && <span className="required-asterisk">*</span>}
          </label>
        )}
      </div>
      {error && (
        <div className="input-error-message">
          {error}
        </div>
      )}
    </div>
  );
};

export default Checkbox; 